export const PRODUCT_LOGIN_CTA_TEST_ID = {
    CONTAINER: 'product-login-cta',
    BUTTON: 'product-login-cta-button',
} as const;
